import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Product from "./Product";
import Footer from "../components/Footer";
import { useParams } from "react-router-dom";
import axios from "axios";
var config = require("../../src/config/dev").default;

const useAllData = () => {
  const [nft, setNft] = useState([]);
  const params = useParams();
  const { tokenId } = params;
  const fetchNft = async () => {
    const nftResult = await axios
      .get(config.API_ENDPOINT+"src/v1/eprnftdetails", {
        headers: {
          "X-Api-Token": sessionStorage.getItem("traceChainAccessToken"),
        },
        params: {
          tokenId: `${tokenId}`,
        },
      })
      .then((res) => {
        //const nftResult = res.data.data.result;
        //console.log("nft=>",nftResult);
        return res.data.data.result;
        //console.log("setNft called");
      })
      .catch((err) => {
        console.log(err);
      });

    await Promise.all(nftResult);
    setNft(nftResult);
  };
  useEffect(() => {
    fetchNft();
  });
  return nft;
};

function ProductPage() {
  // const [nft,setNft] = useState([]);
  // const params = useParams();
  // const {tokenId, tokenAddress} = params;
  //var fetchedProduct;

  const allNft = useAllData();
  //console.log("allNFt==",allNft);
  if (!allNft) return "loading";
  return (
    <div>
      <Navbar />
      <Product nfts={allNft[0]} />
      {/* <Table tokenId={tokenId} tokenAddress={tokenAddress}/> */}
      <Footer />
    </div>
  );
}

export default ProductPage;

/*
name="{nft.name}" 
description="{nft.description}" 
image="{nft.image}" 
ownerName={nft[0].nft_sale[0].ownerName}
price="{nft[0].nft_sale[0].fixedPrice}"
copies="{nft[0].no_of_copies}"
*/
